export class Viewer {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "SessionScope",
            "format": ""
        },
        {
            "name": "eonAccount",
            "baseName": "eonAccount",
            "type": "EonAccount",
            "format": ""
        },
        {
            "name": "eonAccountOrgMembership",
            "baseName": "eonAccountOrgMembership",
            "type": "EonOrganizationSummary",
            "format": ""
        },
        {
            "name": "sessionOriginOrganizationId",
            "baseName": "sessionOriginOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonOrganization",
            "baseName": "eonOrganization",
            "type": "EonOrganization",
            "format": ""
        },
        {
            "name": "selectedRole",
            "baseName": "selectedRole",
            "type": "Role",
            "format": ""
        },
        {
            "name": "roleToProjectsMappings",
            "baseName": "roleToProjectsMappings",
            "type": "{ [key: string]: IDs; }",
            "format": ""
        },
        {
            "name": "samlIdentityProvider",
            "baseName": "samlIdentityProvider",
            "type": "SamlIdentityProvider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Viewer.attributeTypeMap;
    }
    constructor() {
    }
}
